import React from 'react'
import './Text.css'

const Text = props => {
  const classNames = ['Text']

  if (props.large) classNames.push('is-large')
  if (props.small) classNames.push('is-small')
  if (props.slim) classNames.push('is-slim')
  if (props.center) classNames.push('is-center')
  if (props.italic) classNames.push('is-italic')

  return (
    <div className={classNames.join(' ')} style={props.style}>
      {!props.html &&
        <p>{props.children}</p>
      }

      {props.html &&
        <div dangerouslySetInnerHTML={{ __html: props.children }} />
      }
    </div>
  )
}

export default Text